"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var logo = require("../../icons/logo.svg");

var LinkDropdown_1 = require("../dropdowns/LinkDropdown");

var SmallUppercaseLink_1 = require("../links/SmallUppercaseLink");

var Icon_1 = require("../../icons/Icon");

var mainHeaderStyle = hs_web_style_guide_1.css({
  backgroundColor: colors_1.white,
  height: 72,
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
});
var middleLinkStyle = hs_web_style_guide_1.css({
  display: 'inline-block'
});
var middleLinkRightMarginStyle = hs_web_style_guide_1.css({
  marginRight: 40
});
var logoLink = hs_web_style_guide_1.css({
  display: 'block',
  textDecoration: 'none',
  width: 160,
  height: 34
});

var HeaderDropdown = function HeaderDropdown(_a) {
  var renderDropdown = _a.renderDropdown,
      dropdownLinks = _a.dropdownLinks,
      dropdownText = _a.dropdownText;
  return React.createElement("div", null, renderDropdown ? renderDropdown() : React.createElement(LinkDropdown_1.LinkDropdown, {
    links: dropdownLinks,
    position: "right",
    text: dropdownText
  }));
};

var MainHeader =
/** @class */
function (_super) {
  __extends(MainHeader, _super);

  function MainHeader() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  MainHeader.prototype.isActive = function (url) {
    if (typeof window !== 'undefined' && url !== '') {
      // Removing potential query strings params from url
      return window.location.pathname.indexOf(url.split('?')[0]) !== -1;
    }

    return false;
  };

  MainHeader.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        middleLinks = _a.middleLinks,
        logoAriaLabel = _a.logoAriaLabel,
        _b = _a.dropdownText,
        dropdownText = _b === void 0 ? '' : _b,
        _c = _a.dropdownLinks,
        dropdownLinks = _c === void 0 ? [] : _c,
        _d = _a.renderDropdown,
        renderDropdown = _d === void 0 ? function () {
      return null;
    } : _d;
    return React.createElement("header", __assign({}, mainHeaderStyle), React.createElement("div", null, React.createElement("a", __assign({
      href: "/",
      "aria-label": logoAriaLabel
    }, logoLink), React.createElement(Icon_1.Icon, {
      width: 160,
      height: 34,
      fill: colors_1.jaffa,
      src: logo
    }))), React.createElement("div", null, middleLinks.map(function (link, index) {
      return React.createElement("div", {
        key: index,
        className: middleLinkStyle + " " + (index < middleLinks.length - 1 ? middleLinkRightMarginStyle : '')
      }, React.createElement(SmallUppercaseLink_1.SmallUppercaseLink, {
        name: link.name,
        url: link.url,
        active: _this.isActive(link.url)
      }));
    })), React.createElement(HeaderDropdown, {
      dropdownText: dropdownText,
      dropdownLinks: dropdownLinks,
      renderDropdown: renderDropdown
    }));
  };

  return MainHeader;
}(React.Component);

exports.MainHeader = MainHeader;